import * as React from 'react'
import { ReactElement } from 'react'
import { MainDto } from '../../config/filePartyConfig'
import EntityCombobox, { EntityComboboxProps } from './EntityCombobox'
import { FilePartyMetaDataDto } from '../../config/finance/invoiceConfig'

export type FilePartyComboboxProps = Partial<EntityComboboxProps<MainDto | FilePartyMetaDataDto>> &
    Required<
        Pick<EntityComboboxProps<MainDto | FilePartyMetaDataDto>, 'selectedOptions' | 'onOptionSelect' | 'dataPromise'>
    >

export default function FilePartyCombobox(props: FilePartyComboboxProps): ReactElement {
    return (
        <EntityCombobox<MainDto | FilePartyMetaDataDto>
            getEntityLabel={party => party.displayName.replaceAll('\n', ' ')}
            getEntityValue={party => party.pivotId}
            getGroupLabel={party => party.role}
            getGroupValue={party => party.role}
            placeholderKey={'base.partycombobox.placeholder'}
            {...props}
        />
    )
}
